<template>
	<div class="home">
		<Header :active="0"></Header>
		<div class="banner">
			<!-- indicator-position="none" arrow="always" -->
			<el-carousel trigger="click" height="680px" @change="carousel" :interval="5000">
				<el-carousel-item v-for="(item,index) in bannerList" :key="index">
					<template v-if="item.type=='image'">
						<img :class="{textOn:bannerOn==index}" class="text" :src="item.imgText">
						<img class="back" :src="item.imgBack">
					</template>
					<template v-if="item.type=='video'">
						<img @click="videoPlayerTo(index)" class="back" :src="item.imgBack">
					</template>
				</el-carousel-item>
			</el-carousel>
		</div>
		<div class="modular modular-1">
			<div class="content">
				<img src="../assets/t1/p1.png">
				<div id="id1" class="right">
					<h1>基于区块链技术的</h1>
					<h3>人力资源全流程、一站式综合服务平台</h3>
					<p>The one-stop management platform for enterprise employment can comprehensively improve the talent
						management ability of enterprises</p>
				</div>
			</div>
		</div>
		<div class="modular modular-2">
			<div id="id2" class="content">
				<div v-for="(item,index) in serviceList" :key="index" class="list">
					<img :src="item.img">
					<p>{{item.name}}</p>
				</div>
			</div>
		</div>
		<div class="modular modular-3">
			<div class="content">
				<div class="title"></div>
				<div class="list">
					<div v-for="(item,index) in technologyList" :key="index" class="jishuDom">
						<div class="imgDom">
							<img :src="item.img">
						</div>
						<p>{{item.name}}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="modular modular-4">
			<div class="content">
				<div class="title"></div>
				<div id="id3" class="list">
					<img class="to1" src="../assets/t4/p6.png">
					<img class="to2" src="../assets/t4/p8.png">
					<img class="to3" src="../assets/t4/p9.png">
					<img class="to4" src="../assets/t4/p3.png">
					<img class="to5" src="../assets/t4/p7.png">
					<img class="to6" src="../assets/t4/p2.png">
					<img class="to7" src="../assets/t4/p5.png">
					<img class="to8" src="../assets/t4/p1.png">
				</div>
			</div>
		</div>
		<div class="modular-5">
			<div id="id7" class="content"></div>
			<div id="id4" class="mp">
				<div>
					<div class="introduce">
						<div class="left">1</div>
						<div class="right">
							<p>求职需求</p>
							<span>百万名企、海量岗位、立体直观、高效便捷</span>
						</div>
					</div>
					<div class="introduce">
						<div class="left">2</div>
						<div class="right">
							<p>链长体系</p>
							<span>刚需副业、团队管理、收益清晰、安全快捷</span>
						</div>
					</div>
					<div class="introduce">
						<div class="left">3</div>
						<div class="right">
							<p>数据中心</p>
							<span>数字身份、消息提醒、成长经历、个性服务</span>
						</div>
					</div>
				</div>
				<div>
					<div class="introduce">
						<div class="left">4</div>
						<div class="right">
							<p>求职需求</p>
							<span>百万名企、海量岗位、立体直观、高效便捷</span>
						</div>
					</div>
					<div class="introduce">
						<div class="left">5</div>
						<div class="right">
							<p>信息管理</p>
							<span>电子简历、在/离职证明、薪资查询、合同管理</span>
						</div>
					</div>
					<div class="introduce">
						<div class="left">6</div>
						<div class="right">
							<p>增值服务</p>
							<span>法律援助、金融服务、培训教育、文化娱乐</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modular modular-6">
			<div id="id5" class="content"></div>
			<div class="imgList">
				<div class="g1">
					<img src="../assets/t6/p1.png">
				</div>
				<div class="g2">
					<img src="../assets/t6/p3.png">
				</div>
				<div class="g3">
					<img src="../assets/t6/p5.png">
				</div>
				<div class="g4">
					<img src="../assets/t6/p8.png">
				</div>
				<div class="g5">
					<img src="../assets/t6/p9.png">
				</div>
				<div class="g6">
					<img src="../assets/t6/p11.png">
				</div>
				<div class="g7">
					<img src="../assets/t6/p9.png">
				</div>
				<div class="g8">
					<img src="../assets/t6/p4.png">
				</div>
				<div class="g9">
					<img src="../assets/t6/p6.png">
				</div>
				<div class="g10">
					<img src="../assets/t6/p7.png">
				</div>
				<div class="g11">
					<img src="../assets/t6/p10.png">
				</div>
				<div class="g12">
					<img src="../assets/t6/p12.png">
				</div>
				<div class="g13">
					<img src="../assets/t6/p13.png">
				</div>
			</div>
		</div>
		<div class="modular modular-7">
			<div class="content">
				<div id="id6" class="imgListOn">
					<img class="p1" src="../assets/t7/p9.png">
					<img class="p2" src="../assets/t7/p8.png">
					<img class="p3" src="../assets/t7/p4.png">
					<img class="p4" src="../assets/t7/p5.png">
					<img class="p5" src="../assets/t7/p2.png">
					<img class="p6" src="../assets/t7/p7.png">
					<img class="p7" src="../assets/t7/p3.png">
					<img class="p8" src="../assets/t7/p6.png">
				</div>
				<div class="address">
					<div class="div1" style="top: 502px;left: 156px;">保健</div>
					<div class="div3" style="top: 492px;left: 289px;">公益</div>
					<div class="div2" style="top: 646px;left: 159px;">文娱</div>
					<div class="div1" style="top: 583px;left: 285px;">
						<p>灵活<br />用工</p>
					</div>
					<div class="div2" style="top: 443px;left: 458px;">旅游</div>
					<div class="div3" style="top: 709px;left: 375px;">商城</div>
					<div class="div3" style="top: 443px;left: 673px;">交通</div>
					<div class="div1" style="top: 445px;left: 832px;">教育</div>
					<div class="div3" style="top: 501px;left: 746px;">司法</div>
					<div class="div2" style="top: 572px;left: 860px;">医疗</div>
					<div class="div1" style="top: 517px;left: 966px;">保险</div>
					<div class="div3" style="top: 566px;left: 1060px;">金融</div>
					<div class="div2" style="top: 718px;left: 720px;">餐饮</div>
					<div class="div1" style="top: 683px;left: 903px;">房产</div>
				</div>
			</div>
		</div>
		<div class="modular modular-8"></div>
		<div class="modular modular-9">
			<div class="content"></div>
		</div>
		<div class="popon">
			<!-- <div class="Ceiling-code">
				<img src="../assets/banner/codeOn.png" >
			</div> -->
			<div v-if="CeilingOn" @click="topFunction" class="Ceiling"></div>
		</div>
		<el-dialog title="视频播放" :visible.sync="centerDialogVisible" width="50%" center>
			<videoPlayer :options="playerOptions" ref="videoPlayer" class="video-player"></videoPlayer>
		</el-dialog>
	</div>
</template>

<script>
	import Header from '../components/subHead.vue'
	import {
		videoPlayer
	} from "vue-video-player";
	import "video.js/dist/video-js.css";
	import "vue-video-player/src/custom-theme.css";
	export default {
		name: 'Home',
		components: {
			Header,
			videoPlayer
		},
		metaInfo: {
			title: '上职家'
		},
		data() {
			return {
				bannerOn: 0,
				centerDialogVisible: false,
				styleList: [1, 2, 3, 4, 5, 6, 7],
				playerOptions: {
					autoplay: true,
					preload: "auto",
					fluid: true, 
					aspectRatio: "16:9",
					playbackRates: [0.5, 1.0, 1.5, 2.0],
					language: "zh-CN",
					sources: [{
						type: "video/mp4", // 类型
						src: "" // url地址
					}],
					loop: true,
					notSupportedMessage: "此视频暂无法播放，请稍后再试"
				},
				bannerList: [{
						type: 'image',
						imgText: require('../assets/banner/text.png'),
						imgBack: require('../assets/banner/banner1.png')
					},
					{
						type: 'video',
						mv: 'https://szj-asset.oss-cn-shenzhen.aliyuncs.com/official/icon/MV.mp4',
						imgBack: require('../assets/banner/banner2.png')
					}
				],
				serviceList: [{
						name: '就业',
						img: require('../assets/t2/p3.png')
					},
					{
						name: '保险',
						img: require('../assets/t2/p1.png')
					},
					{
						name: '培训',
						img: require('../assets/t2/p6.png')
					},
					{
						name: '金融',
						img: require('../assets/t2/p2.png')
					},
					{
						name: '旅游',
						img: require('../assets/t2/p5.png')
					},
					{
						name: '生活消费',
						img: require('../assets/t2/p7.png')
					},
					{
						name: '学历提升',
						img: require('../assets/t2/p8.png')
					}
				],
				technologyList: [{
						name: "基于区块链技术的人力资源库",
						img: require('../assets/t3/p4.png')
					},
					{
						name: "基于区块链技术的薪资给付系统",
						img: require('../assets/t3/p6.png')
					},
					{
						name: "智能劳动合同",
						img: require('../assets/t3/p8.png')
					},
					{
						name: "智能用工匹配系统",
						img: require('../assets/t3/p7.png')
					},
					{
						name: "基于区块链技术的人才诚信体系",
						img: require('../assets/t3/p3.png')
					},
					{
						name: "基于区块链技术的工分体系",
						img: require('../assets/t3/p9.png')
					},
					{
						name: "云视频直播体系",
						img: require('../assets/t3/p5.png')
					},
					{
						name: "区块链+灵活用工模式",
						img: require('../assets/t3/p2.png')
					}
				],
				CeilingOn: false
			}
		},
		mounted() {
			this.topFunction();
			window.addEventListener('scroll', this.scrollToTop);
		},
		beforeDestroy() {
			console.log('销毁');
			window.removeEventListener('scroll', this.scrollToTop);
		},
		methods: {
			/**
			 * 打开视频
			 */
			videoPlayerTo(i){
				this.playerOptions.sources[0].src = this.bannerList[i].mv;
				this.centerDialogVisible=true;
				this.$refs.videoPlayer.player.pause()
			},
			/**
			 * 返回顶部
			 */
			topFunction() {
				document.body.scrollTop = 0;
				document.documentElement.scrollTop = 0;
			},
			carousel(i) {
				// console.log(i, '轮播图索引');
				this.bannerOn = i;
			},
			scrollToTop() {
				// 获取视窗高度
				var domHight = document.documentElement.clientHeight;
				// dom滚动位置
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				if (scrollTop > 900) { //返回顶部按钮是否显示
					this.CeilingOn = true;
				} else {
					this.CeilingOn = false;
				}
				// 获取监听元素
				var id;
				// 获取监听元素本身高度
				var scrollHeight;
				// 获取监听元素距离视窗顶部距离
				var offsetTop;
				// 获取监听元素距离顶部高度-窗口高度 
				var top;
				// 元素距离底部的高度+元素本身高度
				var bottom;
				if (this.styleList.length > 0) {
					this.styleList.map((i) => {
						id = document.getElementById(`id${i}`);
						scrollHeight = id.scrollHeight;
						offsetTop = id.offsetTop;
						top = offsetTop - domHight > 0 ? offsetTop - domHight : 0;
						bottom = scrollHeight + offsetTop;
						// 页面滚动位置 > 元素距离顶部高度-窗口高度 && 页面滚动位置 < 元素距离顶部高度+元素本身高度
						console.log(scrollHeight, offsetTop, domHight, scrollTop, top, bottom);
						let showHeight = scrollTop - 200;
						if (showHeight >= top && showHeight <= bottom) {
							console.log('元素出现在可视区: ' + i);
							switch (i) {
								case 4:
									id.classList.add("slideIn");
									break
								case 7:
									id.classList.add("FadeInTwo");
									break
								default:
									id.classList.add("FadeIn");
									break
							}
						} else {
							console.log('元素不在了: ' + i);
							id.classList.add("FadeNone");
							switch (i) {
								case 4:
									id.classList.remove("slideIn");
									break
								case 7:
									id.classList.remove("FadeInTwo");
									break
								default:
									id.classList.remove("FadeIn");
									break
							}
						}
					})
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	/deep/.vjs-big-play-button{
		width: 50px;
		height: 50px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		border-radius: 50%;
	}

	.modular-9 {
		height: 257px;

		.content {
			margin: 39px auto;
			height: 179px;
			background: url(../assets/t8/p2.png)no-repeat;
			background-size: cover;
		}
	}

	.modular-8 {
		height: 700px;
		background: url(../assets/t8/p1.png)no-repeat;
		background-size: cover;
	}

	.modular-7 {
		.address {
			.div3 {
				animation: floatY 1000ms 1000ms infinite both;
			}

			.div2 {
				animation: floatY 1000ms infinite both;
			}

			.div1 {
				animation: floatY 2000ms 1000ms infinite both;
			}

			div {
				p {
					font-size: 14px;
					line-height: 1;
					margin-top: 10px;
				}

				width: 46px;
				height: 66px;
				background: url(../assets/t7/p1.png)no-repeat;
				background-size: cover;
				color: #FFFFFF;
				font-size: 16px;
				text-align: center;
				line-height: 47px;
				position: absolute;
			}

			width: 100%;
			height: 850px;
			position: relative;
			top: -850px;
		}

		.imgListOn {
			.p8 {
				width: 169px;
				top: 347px;
				left: 967px;
			}

			.p7 {
				width: 183px;
				top: 343px;
				left: 692px;
			}

			.p6 {
				width: 150px;
				top: 405px;
				left: 164px;
			}

			.p5 {
				width: 133px;
				top: 236px;
				left: 863px;
			}

			.p4 {
				width: 151px;
				top: 288px;
				left: 353px;
			}

			.p3 {
				width: 169px;
				top: 275px;
				left: 58px;
			}

			.p2 {
				width: 131px;
				top: 143px;
				left: 683px;
			}

			.p1 {
				width: 137px;
				top: 151px;
				left: 319px;
			}

			img {
				height: 33px;
				position: absolute;
			}

			img:hover {
				transform: translateY(-5px);
				transition: all 0.2s;
			}

			width: 100%;
			height: 850px;
			position: relative;
			z-index: 100;
		}

		height: 850px;
		background: url(../assets/t7/back.png)no-repeat;
		background-size: cover;
	}

	.modular-6 {
		.imgList {
			.g13 {
				width: 261px;
				height: 119px;
				top: 452px;
				left: 1659px;
			}

			.g12 {
				width: 261px;
				height: 119px;
				top: 319px;
				left: 1659px;
			}

			.g11 {
				width: 440px;
				height: 252px;
				top: 319px;
				left: 1205px;
			}

			.g10 {
				width: 215px;
				height: 251px;
				top: 320px;
				left: 582px;
			}

			.g9 {
				width: 215px;
				height: 155px;
				top: 150px;
				left: 582px;
			}

			.g8 {
				width: 299.5px;
				height: 290px;
				top: 281px;
				left: 268px;
			}

			.g7 {
				width: 253px;
				height: 164px;
				top: 407px;
				left: 0;
			}

			.g6 {
				width: 214px;
				height: 304px;
				top: 0;
				left: 1706px;
			}

			.g5 {
				width: 487px;
				height: 304px;
				top: 0;
				left: 1205px;
			}

			.g4 {
				width: 378px;
				height: 571px;
				top: 0;
				left: 812px;
				// img{
				// 	filter: grayscale(0)!important;
				// }
			}

			.g3 {
				width: 215px;
				height: 135px;
				top: 0;
				left: 582px;
			}

			.g2 {
				width: 300px;
				height: 267px;
				top: 0;
				left: 268px;
			}

			.g1 {
				width: 253px;
				height: 394px;
				top: 0;
				left: 0;
			}

			img:hover {
				transform: scale(1.05);
				transition: all .7s;
				// filter: grayscale(0);
			}

			div {
				img {
					width: 100%;
					height: 100%;
					// filter: grayscale(60%);
				}

				overflow: hidden;
				position: absolute;
				// cursor: pointer;
			}

			width: 100%;
			position: relative;
		}

		.content {
			width: 723px;
			height: 147px;
			background: url(../assets/t6/title.png)no-repeat;
			background-size: cover;
			margin: 43px auto 29px;
		}

		height: 828px;
	}

	.modular-5 {
		.mp {
			.introduce:hover {
				.right {
					p {
						color: #00BCD4;
					}
				}

				.left {
					// width: 40px;
					// height: 36px;
					// line-height: 36px;
					font-size: 18px;
				}
			}

			.introduce {
				.right {
					span {
						font-size: 14px;
					}

					p {
						font-size: 14px;
						font-weight: bold;
						margin-top: -4px;
					}

					color: #333333;
				}

				.left {
					width: 36px;
					height: 32px;
					text-align: center;
					line-height: 32px;
					font-size: 16px;
					color: #FFFFFF;
					background: url(../assets/t5/p2.png)no-repeat;
					background-size: cover;
					margin-right: 10px;
				}

				display: flex;
				margin-bottom: 26px;
				cursor: pointer;
			}

			width: 977px;
			margin:-226px auto 0;
			display: flex;
			justify-content: space-between;
			padding-left: 32px;
		}

		.content {
			width: 921px;
			height: 655px;
			background: url(../assets/t5/p1.png)no-repeat;
			background-size: cover;
			position: relative;
			top: -77px;
			z-index: 10;
		}

		width: 100%;
		height: 630px;
		background-color:#F8F8F8;
	}

	.modular-4 {
		.list {
			.to8 {
				top: 413px;
				right: 101px;
			}

			.to7 {
				top: 266px;
				right: 45px;
			}

			.to6 {
				top: 123px;
				right: 63px;
			}

			.to5 {
				top: 0;
				right: 126px;
			}

			.to4 {
				top: 413px;
				left: 150px;
			}

			.to3 {
				top: 266px;
				left: 21px;
			}

			.to2 {
				top: 123px;
				left: 34px;
			}

			.to1 {
				top: 0;
				left: 170px;
			}

			img:hover {
				transform: translateY(-10px);
				transition: all 0.8s;
			}

			img {
				width: 215px;
				height: 63px;
				position: absolute;
				cursor: pointer;
			}

			position: relative;
			width: 100%;
			height: 500px;
		}

		height: 760px;
		background: url(../assets/t4/p10.png)no-repeat;
		background-size: cover;

		.title {
			width: 143px;
			height: 61px;
			margin: 40px auto;
			background: url(../assets/t4/p4.png)no-repeat;
			background-size: cover;
		}
	}

	.modular-3 {
		margin-bottom: 10px;

		.list {
			.jishuDom:hover {
				.imgDom {
					img {
						transform: scale(1.05);
						transition: all 0.8s;
					}

					background-color: #F7FDFE;
					border: 1px solid #00BCD4 !important;
				}

				p {
					color: #00BCD4;
				}
			}

			.jishuDom {
				p {
					font-size: 16px;
					color: #333333;
					margin-top: 29px;
				}

				.imgDom {
					img {
						width: 235px;
						height: 270px;
						margin-top: 20px;
					}

					width: 270px;
					height: 310px;
					border: 1px solid #DDDDDD;
					box-sizing: border-box;
				}

				width: 270px;
				text-align: center;
				margin-bottom: 30px;
			}

			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
		}

		.title {
			width: 138px;
			height: 55px;
			margin: 40px auto;
			background: url(../assets/t3/p1.png)no-repeat;
			background-size: cover;
		}
	}

	.modular-2 {
		.content {
			.list:hover {
				margin-bottom: 20px;
			}

			.list {
				img {
					width: 30px;
					height: 30px;
					margin-bottom: 5px;
				}

				font-size: 16px;
				color: #FFFFFF;
				text-align: center;
				margin-top: 13px;
				cursor: pointer;
			}

			display: flex;
			align-items: center;
			justify-content: space-around;
			width: 1020px;
			height: 120px;
			margin: 604px auto 0;
			background: url(../assets/t2/p4.png)no-repeat;
			background-size: cover;
		}

		background: url(../assets/t2/back.png)no-repeat;
		background-size: cover;
		height: 766px;
	}

	.modular-1 {
		.right {
			p {
				color: #999999;
				font-size: 14px;
			}

			h3 {
				font-size: 32px;
				font-weight: bold;
				margin-bottom: 25px;
			}

			h1 {
				font-size: 48px;
				font-weight: bold;
				margin: 90px 0 20px;
			}

			h1,
			h3 {
				color: #333333;
			}
		}

		img {
			width: 586px;
			height: 432px;
			margin-right: 53px;
		}

		background: url(../assets/t1/p2.png)no-repeat;
		background-size: 100% 100%;
		background-attachment:fixed;
		height: 560px;

		.content {
			display: flex;
			margin-top: 64px;
		}
	}

	.modular {
		width: 100%;
		overflow: hidden;
		background-position: center center;
	}
	.Ceiling-code{
		width: 46px;
		height: 46px;
		background: url(../assets/banner/code.png)no-repeat;
		background-size: cover;
		margin-bottom: 20px;
	}
	.Ceiling-code:hover img{
		display: block;
	}
	.Ceiling:hover {
		margin-top: -5px;
	}
	
	.Ceiling {
		width: 46px;
		height: 46px;
		background: url(../assets/banner/top.png)no-repeat;
		background-size: cover;
		animation: jump 1000ms both;
	}
	.popon{
		width: 46px;
		position: fixed;
		top: 80%;
		right: 80px;
		cursor: pointer;
		z-index: 101;
		img{
			width: 242px;
			height: 109px;
			position: absolute;
			top: -57px;
			right: 50px;
			display: none;
		}
	}
	/deep/.el-carousel__arrow--right {
		left: 80%;
	}

	/deep/.el-carousel__arrow--left {
		left: 77%;
	}

	/deep/.el-carousel__arrow {
		border-radius: 0 !important;
		border: 1px solid #FFFFFF;
		background-color: rgb(31 45 61 / 0%) !important;
		top: 599px !important;
	}

	/deep/.el-carousel__arrow:hover {
		background-color: rgb(31 45 61 / 30%) !important;
	}

	.banner {
		.textOn {
			animation: fadeInUp 1800ms both;
		}

		.text {
			width: 776px;
			height: 206px;
			position: absolute;
			top: 29%;
			left: 18%;
			transform: translate(-50%, -50%);
		}

		.back {
			width: 100%;
			height: 100%;
		}

		width: 100%;
		height: 680px;
		background-color: #52a0d0;
	}

	.content {
		width: 1200px;
		margin: auto;
	}

	.home {
		overflow: hidden;
		width: 100%;
	}
</style>
